import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@lib/api';
import type { ModulKey } from '@lib/modules';

export interface ModulAyari {
  modul: ModulKey;
  aktif: boolean;
  sira: number;
}

const QK = ['modul-ayar'] as const;

export function useModulAyarlari() {
  return useQuery({
    queryKey: QK,
    queryFn: () =>
      api.get('modul-ayar').json<{ data: ModulAyari[] }>().then((r) => r.data),
    staleTime: 5 * 60_000,
  });
}

export function useUpdateModulAyari() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ modul, aktif, sira }: { modul: ModulKey; aktif?: boolean; sira?: number }) =>
      api.patch(`modul-ayar/${modul}`, { json: { aktif, sira } }).json(),
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}
